export default "__VITE_PUBLIC_ASSET__28ee5661__"